import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { CodesMarqueResponse, ContratsListResponse, FieldConfigResponse, Traite } from '../../core/models/traite.model';

@Injectable({ providedIn: 'root' })
export class TraitesService {
  private readonly http = inject(HttpClient);

  getCodesMarque(): Observable<CodesMarqueResponse> {
    return this.http.get<CodesMarqueResponse>(
      `${environment.apiBaseUrl}/correspondance-marques`
    );
  }

  getContratsByCodeMarque(codeMarque: string): Observable<ContratsListResponse> {
    const params = new HttpParams().set('code_marque', codeMarque);
    return this.http.get<ContratsListResponse>(
      `${environment.apiBaseUrl}/marques`,
      { params }
    );
  }

  getByCodeInterne(codeInterne: string): Observable<Traite> {
    return this.http.get<Traite>(
      `${environment.apiBaseUrl}/marques/${encodeURIComponent(codeInterne)}`
    );
  }

  getFieldConfig(tableName: string): Observable<FieldConfigResponse> {
    const params = new HttpParams().set('table', tableName);
    return this.http.get<FieldConfigResponse>(
      `${environment.apiBaseUrl}/field-config`,
      { params }
    ).pipe(
      // Dégradation gracieuse : toute erreur HTTP retourne une liste vide (AC5)
      catchError(() => of({ fields: [], count: 0 }))
    );
  }

  updateTraite(codeInterne: string, updates: Record<string, string>): Observable<void> {
    return this.http.put<void>(
      `${environment.apiBaseUrl}/marques/${encodeURIComponent(codeInterne)}`,
      updates
    );
  }

  createTraite(data: Record<string, string>): Observable<{ message: string; code_interne: string }> {
    return this.http.post<{ message: string; code_interne: string }>(
      `${environment.apiBaseUrl}/marques`,
      data
    );
  }

  deleteTraite(codeInterne: string): Observable<{ message: string; code_interne: string }> {
    return this.http.delete<{ message: string; code_interne: string }>(
      `${environment.apiBaseUrl}/marques/${encodeURIComponent(codeInterne)}`
    );
  }

  uploadLogo(
    codeInterne: string,
    file: File,
    logoField = 'logotype_marque_defaut'
  ): Observable<{ message: string; code_interne: string; logo_presigned_url: string | null }> {
    const params = logoField !== 'logotype_marque_defaut'
      ? new HttpParams().set('field', logoField)
      : undefined;
    return this.http.put<{ message: string; code_interne: string; logo_presigned_url: string | null }>(
      `${environment.apiBaseUrl}/marques/${encodeURIComponent(codeInterne)}/logo`,
      file,
      { headers: { 'Content-Type': file.type }, ...(params ? { params } : {}) }
    );
  }
}

